import { dataAttribute } from "./dataAttribute.js";
import { toKebabCase } from "../string-utilities/kebabCase.js";
function stateDataAttributes(state) {
  return Object.fromEntries(Object.entries(state).map(
    ([key, value]) => [`data-${toKebabCase(key).toLowerCase()}`, dataAttribute(value)]
  ));
}
export {
  stateDataAttributes
};
//# sourceMappingURL=stateDataAttributes.js.map
